"use client";

import React from "react";
import { Shield, Server, Globe, CreditCard, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * PagemakerForAllIndustries — Section 4: Trust-Bar
 * Drop-in für: src/pages/PagemakerForAllIndustries/sections/TrustAndCredibility.tsx
 */

const items = [{
  label: "WordPress",
  sublabel: "Open Source · keine Abhängigkeit",
  Icon: Globe
}, {
  label: "Google Cloud",
  sublabel: "Enterprise-Hosting weltweit",
  Icon: Server
}, {
  label: "Cloudflare CDN",
  sublabel: "Blitzschnell auf jedem Gerät",
  Icon: ShieldCheck
}, {
  label: "SSL inklusive",
  sublabel: "Verschlüsselt nach Standard",
  Icon: Shield
}, {
  label: "Twint &amp; Stripe",
  sublabel: "Schweizer Zahlungsintegration",
  Icon: CreditCard
}];
export default function TrustAndCredibility() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-12 md:py-16 border-y border-border">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <p className="text-center text-xs font-semibold tracking-[0.2em] text-muted-foreground uppercase mb-8">
          Auf vertrauenswürdiger Technologie gebaut
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-y-8 gap-x-4">
          {items.map(it => <div key={it.label} className="flex flex-col items-center text-center px-2">
              <div className="mb-3 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-background text-foreground border border-border">
                <it.Icon className="w-5 h-5" strokeWidth={1.5} />
              </div>
              <div className="text-sm font-bold text-foreground tracking-tight" dangerouslySetInnerHTML={{
            __html: it.label
          }} />
              <div className="text-[11px] text-muted-foreground mt-1 leading-snug">
                {it.sublabel}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}